var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "px-3 pb-0" },
    [
      _vm.mostrarModalConfirmacao
        ? _c("ConfirmacaoModal", {
            attrs: {
              showDialog: _vm.mostrarModalConfirmacao,
              tituloModal: _vm.tituloModalConfirmacao,
              textoModal: _vm.textoModalConfirmacao,
              btnConfirmarEmit: _vm.btnConfirmarModalConfirmacao,
              esconderCancelar: false,
              btnConfirmar: _vm.btnConfirmarLabel
            },
            on: {
              invalidarInstrumento: _vm.invalidarInstrumento,
              fecharModal: function($event) {
                _vm.mostrarModalConfirmacao = false
                _vm.esconderCancelar = false
              }
            }
          })
        : _vm._e(),
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h4", { staticClass: "bold" }, [_vm._v("Informações do Título")])
          ]),
          _c(
            "v-col",
            { staticClass: "d-flex justify-end" },
            [
              _c("select-actions", {
                attrs: {
                  actions: [
                    {
                      name: "Irregularizar: Cartório inativo",
                      method: "irregularizarTitulo",
                      disabled: !_vm.statusParaIrregularizarTitulo.includes(
                        _vm.titulo.cd_status
                      )
                    },
                    {
                      name: "Irregularizar: Erro do cartório",
                      method: "irregularizarTituloK3",
                      disabled: !_vm.statusParaIrregularizarTituloK3.includes(
                        _vm.titulo.cd_status
                      )
                    },
                    {
                      name: "Enviar a Negociação",
                      method: "enviarNegociacao",
                      disabled: !_vm.statusParaRenegociarProtestar.includes(
                        _vm.titulo.cd_status
                      )
                    },
                    {
                      name: "Enviar a Protesto",
                      method: "enviarProtesto",
                      disabled: !_vm.statusParaRenegociarProtestar.includes(
                        _vm.titulo.cd_status
                      )
                    },
                    {
                      name: "Reiniciar Envio",
                      method: "reiniciarEnvio",
                      disabled: _vm.desabilitaBotaoFila
                    },
                    {
                      name: "Invalidar Instrumento de Protesto",
                      method: "modalInvalidarInstrumento",
                      disabled: !_vm.instrumentoProtesto
                    },
                    {
                      name: "Resumo do Título",
                      method: "copiarResumoTitulo",
                      disabled: false
                    }
                  ]
                },
                on: { executeAction: _vm.callMethod }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.cd_status + " - " + _vm.titulo.ds_status,
                  label: "Status",
                  readonly: "",
                  "hide-details": "auto"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3", attrs: { cols: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.id_titulo,
                  label: "ID",
                  readonly: "",
                  "hide-details": "auto"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3", attrs: { cols: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.ds_numero_titulo,
                  label: "Número do Título",
                  readonly: "",
                  "hide-details": "auto"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3", attrs: { cols: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.nu_parcela,
                  label: "Parcela",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3", attrs: { cols: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.ds_nosso_numero,
                  label: "Nosso Número",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-0" },
        [
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: "R$ " + _vm.titulo.vl_saldo_protesto_formatado,
                  label: "Valor Protestado",
                  readonly: "",
                  "hide-details": "auto"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: "R$" + _vm.titulo.vl_titulo_formatado,
                  label: "Valor total do Título",
                  readonly: "",
                  "hide-details": "auto"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.formatDate(_vm.titulo.dt_emissao),
                  label: "Data de emissão",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.formatDate(_vm.titulo.dt_vencimento),
                  label: "Data de vencimento",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: "R$ " + (_vm.titulo.vl_repassado_formatado || "0,00"),
                  label: "Valor Repasse",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          [103, 121].includes(_vm.titulo.cd_status)
            ? _c(
                "v-col",
                { staticClass: "pb-3" },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      value: "R$ " + (_vm.titulo.vl_custas_formatado || "0,00"),
                      label: "Custas Finais",
                      "hide-details": "auto",
                      readonly: ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-0" },
        [
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.cd_especie_titulo,
                  label: "Espécie",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.tp_declaracao,
                  label: "Declaração",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.tp_endosso || " ",
                  label: "Endosso",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.tp_aceite,
                  label: "Aceite",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.cd_falimentar || "  ",
                  label: "Falimentar",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-3" },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  value: _vm.titulo.ds_agrupador,
                  label: "Agrupador",
                  "hide-details": "auto",
                  readonly: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-0" },
        [
          _vm.valorEmolumentoReal.total == 0
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "4" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: "Valor estimado de Emolumentos",
                      required: "",
                      readonly: ""
                    },
                    model: {
                      value: _vm.valorEmolumento,
                      callback: function($$v) {
                        _vm.valorEmolumento = $$v
                      },
                      expression: "valorEmolumento"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.valorEmolumentoReal.total != 0
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "4" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c("v-text-field", {
                        staticClass: "flex-grow-1",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          label: "Valor Real de Emolumentos",
                          required: "",
                          readonly: ""
                        },
                        model: {
                          value: _vm.valorEmolumentoReal.total,
                          callback: function($$v) {
                            _vm.$set(_vm.valorEmolumentoReal, "total", $$v)
                          },
                          expression: "valorEmolumentoReal.total"
                        }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          { staticClass: "ml-2" },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" mdi-information-outline ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1801358529
                          )
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "text-left" },
                            _vm._l(_vm.valorEmolumentoRealFiltrado, function(
                              item,
                              key
                            ) {
                              return _c("p", { key: key }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.label) +
                                    ": " +
                                    _vm._s(item.value) +
                                    " "
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.feedbackSnackbar
        ? _c("Snackbar", {
            attrs: {
              "data-html2canvas-ignore": "",
              mostrarSnackbar: _vm.feedbackSnackbar,
              corSnackbar: _vm.feedbackSnackbarColor,
              mensagemSnackbar: _vm.mensagemfeedbackSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.feedbackSnackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }